import React, { useState, useEffect, useRef } from 'react';
import SignInCmp from '../../Components/SignInCmp';
import SSLogo from '../../Components/SSLogo';
import SSStackFrame from '../../Components/SSStackFrame';
import BGImage from '../../assets/bg-blur.png';
import './signinpage.scss';
import AccountBox from '../../Components/AccountBox';
import FooterLayout from '../../layouts/FooterLayout';
import { getParameterByName } from '../../utils';

export default function SignInPage() {
  const [containerHeight, setContainerHeight] = useState(0);
  const containerRef = useRef(null);
  const ssoProvider = getParameterByName('provider');
  console.log(ssoProvider, 'ssoProvider');
  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      if (!Array.isArray(entries) || !entries.length) {
        return;
      }
      setContainerHeight(entries[0].target.offsetHeight);
    });

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        resizeObserver.unobserve(containerRef.current);
      }
    };
  }, []);

  return (
    <>
      <div
        className="ss-signinpage"
        // style={{
        //   backgroundImage: `url(${BGImage})`,
        // }}
        ref={containerRef}
      >
        <div className="stack-logo">
          <SSLogo />
        </div>
        <div className="sign-in-cmp">
          {/* <SignInCmp /> */}
          <AccountBox ssoProvider={ssoProvider} />
        </div>
        <FooterLayout />
      </div>
      <video
        style={{ height: `${containerHeight}px` }}
        autoPlay
        preload="true"
        muted
        type="video/mp4"
        src="https://sales-stack-chrome-extension-assets.s3.eu-west-2.amazonaws.com/le-tutorial-welcome.mp4"
      />
    </>
  );
}
